import React from 'react'
import { t } from 'i18next'
import mobileIcon from 'Assets/Images/Generals/mobile.png'
import cottageIcon from 'Assets/Images/Generals/cottage.png'
import officeIcon from 'Assets/Images/Generals/office.png'
import houseIcon from 'Assets/Images/Generals/house.png'
import departmentIcon from 'Assets/Images/Generals/department.png'
import shoppingCenterIcon from 'Assets/Images/Generals/shoppingCenter.png'
import projectIcon from 'Assets/Images/Generals/project.png'
import { buildingTypeIds, telephoneTypeIds } from 'Utils/constants'

export const getBuildingTypes = () => [
  {
    id: buildingTypeIds.casa,
    label: t('ADDRESS_FORM_T.BUILDING_TYPE_CASA'),
    icon: <img src={houseIcon} alt="casa" width={40} height={40} />,
  },
  {
    id: buildingTypeIds.apartamento,
    label: t('ADDRESS_FORM_T.BUILDING_TYPE_APARTAMENTO'),
    icon: <img src={departmentIcon} alt="apartamento" width={40} height={40} />,
  },
  {
    id: buildingTypeIds.centroComercial,
    label: t('ADDRESS_FORM_T.BUILDING_TYPE_CENTRO_COMERCIAL'),
    icon: (
      <img
        src={shoppingCenterIcon}
        alt="centro comercial"
        width={40}
        height={40}
      />
    ),
  },
  {
    id: buildingTypeIds.proyecto,
    label: t('ADDRESS_FORM_T.BUILDING_TYPE_PROYECTO'),
    icon: <img src={projectIcon} alt="proyecto" width={40} height={40} />,
  },
]

export const getPhoneTypes = () => [
  {
    id: telephoneTypeIds.cellPhone,
    label: t('ADDRESS_FORM_T.PHONE_TYPE_CELULAR'),
    icon: <img src={mobileIcon} alt="celular" width={32} height={32} />,
  },
  {
    id: telephoneTypeIds.house,
    label: t('ADDRESS_FORM_T.PHONE_TYPE_CASA'),
    icon: <img src={cottageIcon} alt="casa" width={32} height={32} />,
  },
  {
    id: telephoneTypeIds.office,
    label: t('ADDRESS_FORM_T.PHONE_TYPE_OFICINA'),
    icon: <img src={officeIcon} alt="oficina" width={32} height={32} />,
  },
]

export const UNIT_NUMBER_KEYS = {
  [buildingTypeIds.casa]: 'ADDRESS_FORM_T.UNIT_NUMBER_CASA',
  [buildingTypeIds.apartamento]: 'ADDRESS_FORM_T.UNIT_NUMBER_APARTAMENTO',
  [buildingTypeIds.centroComercial]: 'ADDRESS_FORM_T.UNIT_NUMBER_LOCAL',
  [buildingTypeIds.proyecto]: 'ADDRESS_FORM_T.UNIT_NUMBER_UNIDAD',
}

export const UNIT_NUMBER_PLACEHOLDER_KEYS = {
  [buildingTypeIds.casa]: 'ADDRESS_FORM_T.PLACEHOLDER_UNIT_NUMBER_CASA',
  [buildingTypeIds.apartamento]:
    'ADDRESS_FORM_T.PLACEHOLDER_UNIT_NUMBER_APARTAMENTO',
  [buildingTypeIds.centroComercial]:
    'ADDRESS_FORM_T.PLACEHOLDER_UNIT_NUMBER_LOCAL',
  [buildingTypeIds.proyecto]: 'ADDRESS_FORM_T.PLACEHOLDER_UNIT_NUMBER_UNIDAD',
}

export const showsFloorAndElevator = id =>
  id === buildingTypeIds.apartamento || id === buildingTypeIds.centroComercial
